import { privateApi } from '@/config/axios.config';
import { Settings, UpdateSettingsDTO } from '../types/settings.types';

const API_BASE = '/condominium/settings';

export const settingsApiService = {
  // Obtener configuración del condominio
  async getSettings(): Promise<Settings> {
    const response = await privateApi.get(API_BASE);
    
    // El interceptor global envuelve en { success: true, data: ... }
    const data = response.data?.data || response.data;
    
    return {
      general: data.general || {
        language: 'es',
        timezone: 'America/Santo_Domingo',
        dateFormat: 'DD/MM/YYYY',
        currency: 'DOP',
      },
      account: data.account || {
        name: '',
        email: '',
        phone: '',
      },
      notifications: data.notifications || {
        emailNotifications: true,
        paymentReminders: true,
        maintenanceAlerts: true,
        residentUpdates: true,
      },
      condominium: data.condominium || {
        name: '',
        address: '',
        city: '',
        country: 'República Dominicana',
        phone: '',
        email: '',
      },
      billing: data.billing || {
        plan: 'free',
        billingCycle: 'monthly',
        nextRenewal: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        paymentMethod: 'Visa •••• 8881',
      },
    };
  },

  // Actualizar configuración
  async updateSettings(updateDto: UpdateSettingsDTO): Promise<Settings> {
    const response = await privateApi.patch(API_BASE, updateDto);
    const data = response.data?.data || response.data;
    
    return {
      general: data.general || {
        language: 'es',
        timezone: 'America/Santo_Domingo',
        dateFormat: 'DD/MM/YYYY',
        currency: 'DOP',
      },
      account: data.account || {
        name: '',
        email: '',
        phone: '',
      },
      notifications: data.notifications || {
        emailNotifications: true,
        paymentReminders: true,
        maintenanceAlerts: true,
        residentUpdates: true,
      },
      condominium: data.condominium || {
        name: '',
        address: '',
        city: '',
        country: 'República Dominicana',
        phone: '',
        email: '',
      },
      billing: data.billing || {
        plan: 'free',
        billingCycle: 'monthly',
        nextRenewal: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        paymentMethod: 'Visa •••• 8881',
      },
    };
  },
};

export default settingsApiService;

